import { queryKeysBuilder } from '@/api/queries.utils';

const builder = queryKeysBuilder(['prestation-transactions']);

export const prestationTransactionsQueryKeys = {
  all: builder(),
  one: (id: number) => builder('one', id),
};
